import {
  HomeOutlined,
  SettingOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

export type itemsProps =
  {
    label: string;
    key: string;
    icon: JSX.Element;
    uri?: string;
    permission?: string[];
    onClick?: () => void;
    children?: {
      label: string;
      key: string;
      uri: string;
      permission?: string[];
      onClick?: () => void;
    }[];
  }


export default function MenuItems() {
  let navigate = useNavigate();

  const items: itemsProps[] =
    [

      {
        label: 'INICIO',
        key: '1',
        uri: '/inicio',
        icon: <HomeOutlined />,
        permission: ['ADMINISTRADOR', 'USUARIO', 'ADVOGADO'],
        onClick: () => { navigate('/inicio') },
      },
      {
        label: 'DEMANDAS',
        key: '2',
        // onClick: () => { navigate('/demandas') },
        permission: ['ADMINISTRADOR', 'USUARIO', 'ADVOGADO'],
        icon: <TeamOutlined />,
        children: [
          {
            label: 'Geral',
            key: '3',
            uri: '/demandas/geral',
            onClick: () => { navigate('/demandas/geral') },
          },
          {
            label: 'Previdenciário',
            key: '4',
            uri: '/demandas/previdenciario',
            onClick: () => { navigate('/demandas/previdenciario') },
          },
          {
            label: 'Consumidor',
            key: '5',
            uri: '/demandas/consumidor',
            onClick: () => { navigate('/demandas/consumidor') },
          },
          {
            label: 'Civil',
            key: '6',
            uri: '/demandas/civil',
            onClick: () => { navigate('/demandas/civil') },
          },
          {
            label: 'Trabalhista',
            key: '7',
            uri: '/demandas/trabalhista',
            onClick: () => { navigate('/demandas/trabalhista') },
          },
          {
            label: 'Imobiliário',
            key: '8',
            uri: '/demandas/imobiliario',
            onClick: () => { navigate('/demandas/imobiliario') },
          },
          {
            label: 'Família',
            key: '9',
            uri: '/demandas/familia',
            onClick: () => { navigate('/demandas/familia') },
          },
          {
            label: 'Bancário',
            key: '10',
            uri: '/demandas/bancario',
            onClick: () => { navigate('/demandas/bancario') },
          },
        ],
      },
      {
        label: 'CONFIGURAÇÕES',
        key: '10',
        icon: <SettingOutlined />,
        permission: ['ADMINISTRADOR'],
        children: [
          {
            label: 'Gerenciar usuários',
            key: '11',
            permission: ['ADMINISTRADOR'],
            uri: '/administrativo/usuarios',
            onClick: () => { navigate('/administrativo/usuarios') },
          },
        ]
      }
    ]
  return items;
}
